export default {
  loginout: 'Đăng xuất',
  login: 'đăng nhập',
  logout: 'thoát ra',

  changepasswd: 'thay đổi mật khẩu',
  changeLanguage: 'thay đổi ngôn ngữ',
  safeCenter: 'Trung tâm bảo mật'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/home.js